import { connect } from 'react-redux';
import { closeAgencyDialogCalled, updateAgencySelectionForm } from '../actions';
import AgencyDialog from '../components/AgencyDialog';

const mapStateToProps = state => {
    const {
        agencySelectionForm,
        agencyDialog: { open },
    } = state.teamManagement;
    return {
        agencySelectionForm,
        open,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        updateAgencySelectionForm: agency => dispatch(updateAgencySelectionForm(agency)),
        onCloseAgencyDialog: () => dispatch(closeAgencyDialogCalled()),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(AgencyDialog);
